import script from "./BeritaAcaraHasilPenawaran.vue?vue&type=script&setup=true&lang=js"
export * from "./BeritaAcaraHasilPenawaran.vue?vue&type=script&setup=true&lang=js"

import "./BeritaAcaraHasilPenawaran.vue?vue&type=style&index=0&id=1b8703ba&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8703ba"]])

export default __exports__